import { render, staticRenderFns } from "./InputSwitch.vue?vue&type=template&id=7790153c&scoped=true"
import script from "./InputSwitch.vue?vue&type=script&lang=js"
export * from "./InputSwitch.vue?vue&type=script&lang=js"
import style0 from "./InputSwitch.vue?vue&type=style&index=0&id=7790153c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7790153c",
  null
  
)

export default component.exports